import { AssignmentCreationDTO, AssignmentDTO, assignmentLetterTypeEnum, AssignmentUpdateDTO, GetAllAssignmentDTO, GetAllAssignmentFiltersDTO, GetAllInspectionVisitDTO, GetAllInspectionVisitFiltersDTO, GetAllResultControlActivityDTO, GetAllResultControlActivityFiltersDTO, InspectionVisitCreationDTO, InspectionVisitDTO, InspectionVisitTurnOverFiltersDTO, InspectionVisitUpdateDTO, ResultControlActivityCreationDTO, ResultControlActivityDTO, ResultControlActivityUpdateDTO, TurnOverResponseDTO } from "./dto";
import { AssignmentServiceImpl } from "./serviceImpl";

export interface AssignmentService {
    /* ASSIGNMENT */
    CreateAssignment(data: AssignmentCreationDTO): Promise<string>
    UpdateAssignment(data: AssignmentUpdateDTO, id: string): Promise<void>
    DeleteAssignment(id: string): Promise<void>
    GetAllAssignment(filters: GetAllAssignmentFiltersDTO): Promise<GetAllAssignmentDTO>
    GetAssignmentById(id: string): Promise<AssignmentDTO>
    UploadFileAssSigned(data: FormData, id: string): Promise<void>
    DownloadAssignmentLetter(data:{id: string, infoType: assignmentLetterTypeEnum}): Promise<void>

    /* INSPECTION VISIT */
    CreateInspectionVisit(data: InspectionVisitCreationDTO): Promise<void>
    UpdateInspectionVisit(data: InspectionVisitUpdateDTO, id: string): Promise<void>
    InspectionVisitUploadFile(data: FormData, id: string): Promise<string>
    DeleteInspectionVisit(id: string): Promise<void>
    GetAllInspectionVisit(filters: GetAllInspectionVisitFiltersDTO): Promise<GetAllInspectionVisitDTO>
    GetInspectionVisitById(id: string): Promise<InspectionVisitDTO>
    InspectionVisitTurnOver(inspectorCode: string, customerId: string): Promise<TurnOverResponseDTO>

    /* RESULT CONTROL ACTIVITY */
    CreateResultControlActivity(data: ResultControlActivityCreationDTO): Promise<void>
    UpdateResultControlActivity(data: ResultControlActivityUpdateDTO, id: string): Promise<void>
    DeleteResultControlActivity(id: string): Promise<void>
    GetAllResultControlActivity(filters: GetAllResultControlActivityFiltersDTO): Promise<GetAllResultControlActivityDTO>
    GetResultControlActivityById(id: string): Promise<ResultControlActivityDTO>
}

export function NewAssigmentService(): AssignmentService {
    return new AssignmentServiceImpl()
}